<template>
    <!-- Add -->
    <div
      class="modal fade"
      id="add_item"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isEditMode ? "Update" : "Create" }} {{ title }}
            </h5>
            <div class="d-flex align-items-center">
              <button
                class="btn-close custom-btn-close border p-1 me-0 text-dark"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i class="ti ti-x"></i>
              </button>
            </div>
          </div>
          <form @submit.prevent="submitForm">
            <div class="modal-body">
              <!-- Input Fields -->
              <div class="mb-3">
                <label class="col-form-label"
                  >Name <span class="text-danger">*</span></label
                >
                <input type="text" class="form-control" v-model="name" />
                <div class="text-danger" v-if="errors.name">
                  {{ errors.name[0] }}
                </div>
              </div>
              <div class="mb-3">
                <label class="col-form-label"
                  >Date Range <span class="text-danger">*</span></label
                >
                <Datepicker
                  v-model="dateRange"
                  :range="true"
                  :clearable="true"
                  :format="format"
                  placeholder="Select a date range"
                />
                <div class="text-danger" v-if="errors.start_date">
                  {{ errors.start_date[0] }}
                </div>
                <div class="text-danger" v-if="errors.end_date">
                  {{ errors.end_date[0] }}
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex align-items-center justify-content-end m-0">
                <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                  >Cancel</a
                >
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm"
                  ></span>
                  {{ isEditMode ? "Update" : "Create" }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- /Add  -->
  
    <!-- Delete -->
    <div class="modal fade" id="delete_item" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">
              <div class="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                <i class="ti ti-trash-x fs-36 text-danger"></i>
              </div>
              <h4 class="mb-2">Remove {{ title }}?</h4>
              <p class="mb-0">Are you sure you want to remove it</p>
              <div class="d-flex align-items-center justify-content-center mt-4">
                <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                  >Cancel</a
                >
                <button
                  class="btn btn-danger"
                  @click="deleteItem()"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm"
                  ></span>
                  Yes, Delete it
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Delete -->
  </template>
  <script>
  import http from "@/utils/http";
  import Datepicker from "@vuepic/vue-datepicker";
  import "@vuepic/vue-datepicker/dist/main.css";
  
  export default {
    components: { Datepicker },
    props: {
      isEditMode: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: "",
      },
    },
    data: () => ({
      isLoading: false,
      name: "",
      dateRange: "",
      start_date: "",
      end_date: "",
      format: "yyyy-MM-dd",
      itemId: null,
      errors: {},
    }),
  
    mounted() {
      this.$emitter.on("add-edit-item", (row) => {
        if (row) {
          this.itemId = row.id;
          this.name = row.name;
          this.start_date = row.start_date;
          this.end_date = row.end_date;
  
          if (this.start_date && this.end_date) {
            this.dateRange = [new Date(this.start_date), new Date(this.end_date)];
          }
        } else {
          this.itemId = null;
          this.name = "";
          this.dateRange = "";
          this.start_date = "";
          this.end_date = "";
        }
        this.$handleModal("add_item", "toggle");
      });
  
      this.$emitter.on("delete-item-modal", (row) => {
        if (row) {
          this.itemId = row.id;
        }
        this.$handleModal("delete_item", "toggle");
      });
    },
  
    methods: {
      async submitForm() {
        this.isLoading = true;
        const endpoint = this.isEditMode
          ? `/exhibitions/${this.itemId}`
          : "/exhibitions";
        const method = this.isEditMode ? "put" : "post";
        let body = {
          name: this.name,
          start_date: this.start_date,
          end_date: this.end_date,
        };
        try {
          const response = await http[method](endpoint, body);
  
          this.$toast.success(response.data.message);
          this.$handleModal("add_item", "hide");
          this.$emit("refresh");
        } catch (error) {
          this.errors = error.response.data.errors;
        } finally {
          this.isLoading = false;
        }
      },
      async deleteItem() {
        this.isLoading = true;
        const endpoint = `/exhibitions/${this.itemId}`;
        const method = "delete";
        try {
          const response = await http[method](endpoint);
          this.$toast.success(response.data.message);
          this.$handleModal("delete_item", "hide");
          this.$emit("refresh");
        } catch (error) {
          this.$toast.error(error.response.data.message);
        } finally {
          this.isLoading = false;
        }
      },
      formatDate(date) {
        if (!date) return "";
        // Using toLocaleString to return YYYY-MM-DD HH:mm:ss
        const options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        };
        return new Date(date).toLocaleString("sv-SE", options).replace("T", " ");
      },
    },
    watch: {
      dateRange(newRange) {
        if (newRange) {
          this.start_date = this.formatDate(newRange[0]); // Set formatted start date
          this.end_date = this.formatDate(newRange[1]);
          console.log("start date", this.start_date); // Set formatted end date
        } else {
          this.start_date = "";
          this.end_date = "";
        }
      },
    },
  };
  </script>
  